import ContentPlanPage from './ContentPlanPage';
import ContentPlan from './ContentPlan';
import './assets/content-plan.scss'

export {ContentPlan}
export default ContentPlanPage;